"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ianaTimeZones = exports.ETC_UTC_TIME_ZONE = void 0;
exports.ETC_UTC_TIME_ZONE = 'Etc/UTC';
const ianaTimeZonesDb_1 = require("./ianaTimeZonesDb");
const ianaTimeZones = () => [exports.ETC_UTC_TIME_ZONE, ...ianaTimeZonesDb_1.ianaTimeZonesDb];
exports.ianaTimeZones = ianaTimeZones;
